import React, { useContext } from "react";
import { DataContext } from "../Context/DataContext";
import { AccountType } from "../utility/enums";
import { openHelp } from "./HelpPanel";
import { displayName, teamLine } from "../utility/accountLabels";
import "./AccountUi.css";

// The avatar menu, the same on every page (public pages, checkout, account):
// who is signed in (name, email, team) and Orders · Billing (teams) ·
// Settings · Help · Sign out. Office staff get their portal instead of
// Orders and Billing.
//   onNavigate(path, event)  how the page moves (transitionTo)
//   onSignOut()              the page's own sign-out
//   onDone()                 closes the dropdown (optional)
//   variant                  "dropdown" (default) or "sheet" (phone menus)

const STAFF_PORTAL = {
  [AccountType.OWNER]: "Owner Portal",
  [AccountType.SUPPORT]: "Support Portal",
  [AccountType.SUPPORTPLUS]: "Support Portal",
  [AccountType.TRANSLATER]: "Translator Portal",
};

export const menuItemsFor = (userData, teamData) => {
  if (!userData) return [];
  const portal = STAFF_PORTAL[userData.role];
  if (portal) {
    return [
      { key: "portal", label: portal, path: "/office/translations" },
      { key: "settings", label: "Settings", path: "/account/settings" },
    ];
  }
  return [
    { key: "orders", label: "Orders", path: "/account/orders" },
    ...(userData.teamId && teamData ? [{ key: "billing", label: "Billing", path: "/account/billing" }] : []),
    { key: "settings", label: "Settings", path: "/account/settings" },
    { key: "help", label: "Help", help: true },
  ];
};

const UserMenu = ({ onNavigate, onSignOut, onDone = () => {}, variant = "dropdown", signOutLabel = "Sign out" }) => {
  const { userData, teamData } = useContext(DataContext);
  if (!userData) return null;

  const name = displayName(userData);
  const team = teamLine(userData, teamData);

  const pick = (item) => (e) => {
    e.stopPropagation();
    onDone();
    if (item.help) {
      openHelp();
      return;
    }
    onNavigate(item.path, e);
  };

  return (
    <div className={`userMenu ${variant === "sheet" ? "userMenuSheet" : ""}`} data-testid="user-menu" onClick={(e) => e.stopPropagation()}>
      <div className="userMenuHead">
        {name && <p className="userMenuName">{name}</p>}
        <p className="userMenuEmail">{userData.email}</p>
        {team && <p className="userMenuTeam">{team}</p>}
      </div>
      <div className="userMenuItems">
        {menuItemsFor(userData, teamData).map((item) => (
          <button type="button" key={item.key} className="userMenuItem" data-item={item.key} onClick={pick(item)}>
            {item.label}
          </button>
        ))}
        <button type="button" className="userMenuItem userMenuSignOut" data-item="signout"
          onClick={(e) => { e.stopPropagation(); onDone(); onSignOut(); }}>
          {signOutLabel}
        </button>
      </div>
    </div>
  );
};

export default UserMenu;
